import { ReactNode, useEffect, useState } from 'react'
import { AdminPageAuthApi, AdminPageAuthRoute } from './services/adminPageAuthApi'

interface IAdminPageAuthGuardProps {
  route: AdminPageAuthRoute
  title: string
  children: ReactNode
}

/**
 * Sayfayı yalnız yetkili listesindeki admin'e gösterir. Yetki kontrolü bitene kadar sayfa
 * açılmaz; böylece yetkisiz kullanıcıya boş liste ya da hata yağmuru yerine tek mesaj görünür.
 */
export default function AdminPageAuthGuard(props: IAdminPageAuthGuardProps) {
  const [authorized, setAuthorized] = useState<boolean | null>(null)

  useEffect(() => {
    new AdminPageAuthApi({}, props.route)
      .getAuth()
      .then(result => setAuthorized(result === true))
      .catch(() => setAuthorized(false))
  }, [props.route])

  if (authorized === null) return null

  if (!authorized)
    return (
      <div className='card'>
        <div className='card-header px-4'>
          <span className='h4'>{props.title}</span>
        </div>
        <div className='card-body'>
          <div className='alert alert-danger mb-0'>Bu sayfaya erişim yetkiniz bulunmamaktadır.</div>
        </div>
      </div>
    )

  return <>{props.children}</>
}
